import gql from 'graphql-tag';

const GET_MEDIA_PARTNER_DETAILS = gql`
  query mediaPartnerDetails($id: String!) {
    mediaPartner(id: $id) {
      id
      name
      image
      site
      facebook
      twitter
      resume
      scope
      language
      themes
      locale
      countries
    }
  }
`;

export default GET_MEDIA_PARTNER_DETAILS;



/** WEBPACK FOOTER **
 ** ./src/graphql/GET_MEDIA_PARTNER_DETAILS.js
 **/